import axios from '../utils/axios';

export default function updateResumeBuilderCandidate(data) {
    return (
        axios.post('/resumeBuilder/subscription/admin/updateResumeBuilderUser',  data )
        .then(res => {
            return res
        })
        .catch(err => {
            return err;
        })
    )
}
